import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';


export const state = () => ({
    formData: {"name":"something else","category":"brand","pinned":true,"logo_src":"https://play-lh.googleusercontent.com/-WtIfvZ4wG-viVEAISvuHbeHBGKq0KSWLvd4NQjWWTRMnhq4N8DTzV3WCBXqFYS9RFuY","areAlertsEnabled":true,"query":[],"id":"7"},
    items: []
});

export const getters = {
    formData: state => state.formData,
    items: state => state.items
};

export const mutations = {
    SET_FORM_DATA(state, value) {
        state.formData = cloneDeep({ ...state.formData, ...value });
    },

    REMOVE_FORM_DATA_PROPERTY(state, property) {
        const formData = cloneDeep(state.formData);

        delete formData[property];

        state.formData = cloneDeep(formData);
    },

    SET_DRAGGED_ITEM(state, draggedItem) {
        state.draggedItem = draggedItem;
    },

    SET_ITEMS(state, items) {
        state.items = cloneDeep(items);
    },

    ADD_ITEM(state, item) {
        const index = state.items.findIndex(i => i.id === item.id);

        if (~index) {
            state.items.splice(index, 1, cloneDeep(item));
        } else {
            state.items.push(cloneDeep(item));
        }
    },

    REMOVE_ITEM(state, id) {
        state.items = state.items.filter(item => item.id !== id);
    }
};

export const actions = {
    async index({ commit }, params = {}) {
        const items = await axios.$get('/v1/topics', { params });

        commit('SET_ITEMS', items);

        return items;
    },

    async store({ commit }, { name, type, keywords, query, entityType, entityIds, topic_group_id }) {
        let topic = await axios.$post('/v1/topics', {
            name,
            type,
            topic_group_id,
            keywords,
            query
        });

        topic = await axios.$put(`/v1/topics/${topic.id}`, {
            ...topic,
            query,
            entity_type: entityType,
            entity_ids: entityIds
        });

        commit('ADD_ITEM', topic);

        return topic;
    },

    show(vuexContext, id) {
        return axios.$get(`/v1/topics/${id}`);
    },

    async update({ commit }, { id, params }) {
        const item = await axios.$put(`/v1/topics/${id}`, params);

        commit('ADD_ITEM', item);

        return item;
    },

    async updateInStore({ commit }, topic) {
        commit('ADD_ITEM', topic);
    },

    move(vuexContext, { topic, topicGroupId }) {
        axios.$put(`/v1/topics/move/${topic.id}`, { topicGroupId });

        topic.topic_group_id = topicGroupId;

        return topic;
    },

    async destroy({ commit }, id) {
        await axios.$delete(`/v1/topics/${id}`);
        commit('REMOVE_ITEM', id);
    },

    removeFromStore({ commit }, id) {
        commit('REMOVE_ITEM', id);
    },

    setFormDataProperty({ commit }, { property, value }) {
        commit('SET_FORM_DATA', { [property]: value });
    },

    removeFormDataProperty({ commit }, property) {
        commit('REMOVE_FORM_DATA_PROPERTY', property);
    },

    dragWordEnded({ commit, state }, wordsIndex) {
        const editedFilter = cloneDeep(state.formData.query[wordsIndex]);

        editedFilter.value = cloneDeep([...editedFilter.value, ...state.draggedItem]);

        state.formData.query.splice(wordsIndex, 1, editedFilter);

        commit('SET_DRAGGED_ITEM', null);
    },

    dragStarted({ commit }, item) {
        commit('SET_DRAGGED_ITEM', item);
    },
};
